import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntImpersonateUserIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 10C7.62963 10 6.88889 10 5.77778 10.5352C5.2156 10.8059 3.92593 11.0703 3 11.0703C3.29866 11.1183 3.67759 11.2564 4.10443 11.4121C5.26559 11.8354 6.78132 12.3881 8 11.6055C9.21868 12.3881 10.7344 11.8354 11.8956 11.4121C12.3224 11.2564 12.7013 11.1183 13 11.0703C12.0741 11.0703 10.7844 10.8059 10.2222 10.5352C9.11111 10 8.37037 10 8 10Z"
      />
      <path
        d="M7.5 6.5C7.5 7.88071 6.38071 9 5 9C3.61929 9 2.5 7.88071 2.5 6.5C2.5 5.11929 3.61929 4 5 4C6.38071 4 7.5 5.11929 7.5 6.5Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 8C5.82843 8 6.5 7.32843 6.5 6.5C6.5 5.67157 5.82843 5 5 5C4.17157 5 3.5 5.67157 3.5 6.5C3.5 7.32843 4.17157 8 5 8ZM5 9C6.38071 9 7.5 7.88071 7.5 6.5C7.5 5.11929 6.38071 4 5 4C3.61929 4 2.5 5.11929 2.5 6.5C2.5 7.88071 3.61929 9 5 9Z"
      />
      <path
        d="M13.5 6.5C13.5 7.88071 12.3807 9 11 9C9.61929 9 8.5 7.88071 8.5 6.5C8.5 5.11929 9.61929 4 11 4C12.3807 4 13.5 5.11929 13.5 6.5Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 8C11.8284 8 12.5 7.32843 12.5 6.5C12.5 5.67157 11.8284 5 11 5C10.1716 5 9.5 5.67157 9.5 6.5C9.5 7.32843 10.1716 8 11 8ZM11 9C12.3807 9 13.5 7.88071 13.5 6.5C13.5 5.11929 12.3807 4 11 4C9.61929 4 8.5 5.11929 8.5 6.5C8.5 7.88071 9.61929 9 11 9Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
      />
      <rect x="7" y="6" width="2" height="1" />
    </SntIcon>
  );
};

export default SntImpersonateUserIcon;
